import careEn from "@project/lib/locales/sections/care.en";
import programsEn from "@project/lib/locales/sections/programs.en";
import trustEn from "@project/lib/locales/sections/trust.en";
import communityEn from "@project/lib/locales/sections/community.en";
import pagesEn from "@project/lib/locales/sections/pages.en";
import accountEn from "@project/lib/locales/sections/account.en";
import csrEn from "@project/lib/locales/sections/csr.en";

export const en = {
  common: {
    siteName: "Jivandhara Old Age Home",
    tagline: "Dignity, Care & Compassion for Every Elder",
    careCompassionCommunity: "Care • Compassion • Community",
    verified: "Verified",
    certified: "12A • 80G Certified",
    browseCauses: "Browse causes",
    register: "Register",
    learnMore: "Learn More",
  },
  brand: {
    title: "Jivandhara",
    subtitle: "Old Age Home, Lambha",
  },
  nav: {
    home: "Home",
    about: "About",
    donation: "Donate",
    csr: "CSR",
    bhojanshala: "Bhojanshala",
    events: "Events",
    gaushala: "Gaushala",
    contact: "Contact",
    more: "More",
    initiatives: "Our Initiatives",
  },
  menu: {
    applyAdmission: "Apply for Admission",
    residentCare: "Resident Care",
    elderCareProgram: "Elder Care Program",
    healthcare: "Healthcare",
    gaushala: "Gaushala",
    events: "Events",
    gruhUdhyog: "Gruh Udhyog",
    transparency: "Transparency & Impact",
    tiffinSeva: "Tiffin Seva",
    news: "News",
    committee: "Committee",
    trustees: "Trustees",
    gallery: "Gallery",
    visitorForm: "Visitor Form",
    feedback: "Feedback",
    jainPanchang: "Jain Panchang",
  },
  lang: {
    english: "English",
    gujarati: "ગુજરાતી",
    change: "Change language",
  },
  footer: {
    quickLinks: "Quick Links",
    services: "Our care & Seva",
    reachUs: "Reach Us",
    rights: "All rights reserved.",
    aboutUs: "About Us",
    residentCare: "Resident Care",
    donateLink: "Donate",
    events: "Donation Events",
    contact: "Contact",
    gaushala: "Gaushala",
    bhojanTithi: "Bhojanshala",
    tiffinSeva: "Tiffin Seva",
    gruhUdhyog: "Gruh Udhyog",
    address: "Padmavati Nagar, Indira Nagar, Vibhag 2, Lambha, Ahmedabad – 382405",
    phone: "+91 9725521170, +91 8758413564, +91 9978015424",
    email: "jivandharavrudhashram@gmail.com",
  },
  home: {
    hero: {
      greeting: "Pranam · प्रणाम · પ્રણામ",
      titleLine1: "For Every Ashram Resident Elder",
      titleLine2: "A Loving Home, Every Day",
      sanskrit: "मातृ देवो भव : पितृ देवो भव :",
      description:
        "An all-in-one seva platform providing shelter, food, medical care and dignity to elderly residents — built with compassion for the Jain community & beyond.",
      feature1: "Lifetime resident care",
      feature2: "12A & 80G tax benefits",
      feature3: "Trusted by 1000+ donors",
      admissionApplication: "Admission Application",
      admissionInquiry: "Admission Inquiry",
      watchStory: "Watch Our Story",
      services: {
        medicalCentre: "Bhagwan Mahavir Medical Centre",
        tiffin: "Bhagwan Mahavir Senior Citizen Tiffin Seva",
        gaushala: "Vrindavan Gir Gaushala",
        bhojanshala: "Bhojanshala",
        mahilaUtkarsh: "Mahila Utkarsh Kendra – Sadguna Home Industry",
        donation: "Our Donation",
        csr: "Corporate Social Responsibility (CSR)",
        elderCare: "Elder Care Program",
      },
    },
    statsCard: {
      residents: "Residents",
      caredFor: "Cared For",
      yearsOf: "Years of",
      seva: "Seva",
      generous: "Generous",
      donors: "Donors",
      dailyCare: "Daily Care",
      medical: "Medical",
      shelter: "Shelter",
      thisMonth: "This month",
    },
    trust: {
      heading: "Trusted by Families & Communities Across Gujarat & Bharat",
      residentsCared: "Residents Cared",
      generousDonors: "Well Wishers",
      wellWishers: "Well Wishers",
      servicesToSociety: "Services to Society",
      donationsProcessed: "Services to Society",
      ofTrustedSeva: "Of Trusted Seva",
    },
    admission: {
      badge: "Admission Enquiry",
      heading: "Looking to admit an elder to our home?",
      description:
        "Submit a simple admission application — share applicant, elder and family details. Our team will reach out within 3 working days to guide you through the next steps.",
      feature1: "Free admission enquiry",
      feature2: "Confidential family information",
      feature3: "Personal follow-up call",
      feature4: "Ashram visit & interview",
      applyButton: "Start Admission Inquiry",
      talkButton: "Talk to our team",
      eldersAdmitted: "Elders Admitted",
      howItWorks: "How it works",
      step1: "1. Submit the admission inquiry",
      step2: "2. Initial telephonic review by our team",
      step3: "3. Family meeting & home visit",
      step4: "4. Admission confirmation",
    },
    engage: {
      eyebrow: "Become Part of Our Parivaar",
      heading: "A Home for Every Elder, A Welcome for Every Visitor",
      description:
        "Whether you are looking for a caring home for a loved one or planning to visit our residents, our doors are always open. Start with a simple enquiry and our team will personally guide you through every step.",
      cta: "Talk to Our Team",
    },
    visitors: {
      badge: "Visitor Connect",
      heading: "Planning a visit or sharing your experience?",
      description:
        "Choose the option that best fits your needs. Register your upcoming visit through the Visitor Inquiry Form or share your experience, appreciation, and suggestions using the Visitor Feedback Form.",
      feature1: "Register your upcoming visit",
      feature2: "Share your visit feedback",
      feature3: "Family visitor details supported",
      feature4: "Help us improve every visit",
      applyButton: "Visitor Forms",
      talkButton: "Talk to our Team",
      visitsLogged: "Visitors in a Year",
      howItWorks: "How it works",
      step1: "1. Choose the appropriate visitor form.",
      step2: "2. Complete the required details.",
      step3: "3. Submit your inquiry or feedback.",
      step4: "4. Our team will review and respond if required.",
    },
    visitorChooser: {
      badge: "Visitor Forms",
      title: "How would you like to connect?",
      description:
        "Choose whether you want to share feedback from a past visit, or register an upcoming visit with us.",
      feedbackTitle: "Visitor Feedback Form",
      feedbackDescription:
        "Share your experience, suggestions or appreciation after visiting Jivandhara.",
      feedbackCta: "Open feedback form",
      inquiryTitle: "Visitor Inquiry Form",
      inquiryDescription:
        "Planning a visit? Share visit details, reason for visit and reference information.",
      inquiryCta: "Open inquiry form",
    },
    schemes: {
      eyebrow: "More About Jivandhara",
      heading: "Discover Our Services",
      description:
        "Learn how Jivandhara serves elders and the community through compassionate care, healthcare, seva, and the preservation of our cultural values.",
      residentCareTitle: "Resident Care",
      residentCareDesc:
        "Explore how we provide a safe, caring, and dignified home where every elder is treated with love, respect, and compassion.",
      residentCareButton: "Explore Care",
      gaushalaTitle: "Vrindavan Gir Gaushala",
      gaushalaDesc:
        "Discover our Gaushala, dedicated to caring for indigenous Gir cows while preserving our rich cultural and spiritual heritage.",
      gaushalaButton: "Visit Gaushala",
      tiffinTitle: "Tiffin Seva",
      tiffinDesc: "Provide warm, home-cooked tiffins to residents in need.",
      tiffinButton: "Register",
      healthcareTitle: "Healthcare",
      healthcareDesc:
        "Learn about our medical facilities, regular health check-ups, physiotherapy, and compassionate healthcare services for every resident.",
      healthcareButton: "View Healthcare",
    },
    glimpses: {
      eyebrow: "Glimpses of Seva",
      heading: "Love-filled moments from our home",
      description:
        "Care, companionship and dignity — captured every day at Jivandhara.",
      festivalLabel: "Festival and Celebrations",
      festivalSub: "Sacred festivals and joyful celebrations at Jivandhara",
      gaushalaLabel: "Gaushala",
      gaushalaSub: "Caring for cows at our Vrindavan Gir Gaushala",
      derasarLabel: "Derasar",
      derasarSub: "Daily worship and spiritual serenity at our temple",
      viewGallery: "View Full Gallery",
    },
    testimonials: {
      eyebrow: "Voices of Trust",
      heading: "What our supporters say",
      description:
        "Kind words from donors, families and well-wishers who believe in our seva.",
    },
    pillars: {
      residentCareTitle: "Resident Care",
      residentCareBody:
        "Lifetime shelter, food, daily care and companionship for every resident.",
      medicalTitle: "Medical Support",
      medicalBody:
        "24×7 Ambulance, 24×7 Doctors, daily medicines, hospital tie-ups and emergency care.",
      ritualsTitle: "Rituals & Dignity",
      ritualsBody:
        "From birthdays to last rites — every milestone is observed with respect.",
    },
    shloka: {
      sanskrit: "“यत्र वृद्धाः पूज्यन्ते रमन्ते तत्र देवताः”",
      translation: "Where elders are respected, divinity resides.",
    },
    cta: {
      headingBefore: "Become Part of Our",
      headingHighlight: "Parivaar",
      headingAfter: "",
      description:
        "अतिथि देवो भव : — Visit, volunteer, donate or simply share. Every act of kindness multiplies.",
      donateNow: "Donate Now",
      visitUs: "Visit Us",
    },
    csr: {
      eyebrow: "CSR Partnership",
      headingBefore: "Partner With Us for",
      headingHighlight: "Social Impact",
      description:
        "We are privileged to welcome leading companies as our CSR Partners, joining hands with us to create meaningful change. Together, we can support elderly care, healthcare, nutritious meals, women empowerment through Gruh Udhyog, and community welfare—turning every contribution into a lasting impact.",
      tagline: "Partnering for purpose to create a lasting & meaningful impact.",
      contactUs: "Contact Us",
      viewMore: "View More",
      areaElderCare: "Elderly Care",
      areaHealthcare: "Healthcare",
      areaMeals: "Nutritious Meals",
      areaWomen: "Women Empowerment",
      areaWomenSub: "through Gruh Udhyog",
      areaCommunity: "Community Welfare",
    },
    awards: {
      eyebrow: "Recognition & Honours",
      headingBefore: "Awards &",
      headingHighlight: "Achievements",
      description:
        "Our seva for elders has been recognised by leading media and civic institutions — every honour belongs to our residents, donors and volunteers.",
      a1Title: "Emerging Gujarat 2023 Award",
      a1Desc: "Presented by TV9 Gujarati to Jivandhara Old Age Home.",
      a1Tag: "2023",
      a2Title: "The Rise & Rise of India Inc. – Bharat@75",
      a2Desc: "Presented by TV9 Gujarati to Jivandhara Vruddhashram.",
      a2Tag: "Bharat@75",
      a3Title: "Business Icons 2022 Award",
      a3Desc: "Recognizing Mr. Sandeep Shah, Jeevan Dhara Vruddhashram.",
      a3Tag: "2022",
      a4Title: "Excellence in the Pride of Ahmedabad in Social Service",
      a4Desc: "Award presented to Jivandhara Vruddhashram.",
      a4Tag: "Social Service",
    },
    upcoming: {
      eyebrow: "Upcoming Projects",
      headingBefore: "Building the",
      headingHighlight: "Next Chapter of Seva",
      description:
        "With your blessings and support, Jivandhara is taking its next big steps — a larger home for our elders and dedicated centres for healing and recovery.",
      years: "2027–2028",
      comingSoon: "Coming Soon",
      catElderCare: "Elder Care",
      catHospital: "Hospital",
      catCancerCare: "Cancer Care",
      catRehab: "Rehabilitation",
      ctaButton: "Support the Project",
    },
  },
  csrPage: {
    hero: {
      eyebrow: "CSR Partnership",
      title: "Corporate Social Responsibility (CSR)",
      subtitle:
        "Our partner trusts are registered with the Ministry of Corporate Affairs to undertake CSR activities. Join hands with us to create a lasting social impact.",
    },
    intro: {
      eyebrow: "Why Partner With Us",
      heading: "Turn your CSR commitment into",
      headingHighlight: "meaningful change",
      highlight1Title: "Quick Fund Utilisation",
      highlight1Text:
        "Every rupee goes directly to free shelter, meals and elder care. Utilisation certificates and impact reports are provided for seamless CSR compliance.",
      highlight2Title: "Ground-Level Impact",
      highlight2Text:
        "From Bhojanshala meals and Gaushala care to Gruh Udhyog livelihoods, your contribution powers on-ground programmes at our Lambha campus — with zero middlemen and full transparency.",
      highlight3Title: "Medical Support",
      highlight3Text:
        "Your contribution funds regular health check-ups, emergency care and medicines for our senior residents and the cows sheltered at our Gaushala.",
    },
    benefits: {
      eyebrow: "Why It Matters",
      heading: "The Benefits Your Company Gets",
      subtitle:
        "Partnering with Jivandhara helps your company meet its CSR obligations while creating real, visible change in people's lives.",
      cta: "Become a CSR Partner",
      item1Title: "Fully CSR Compliant",
      item1Text:
        "Elder care, healthcare, hunger relief, women empowerment and animal welfare are eligible under Schedule VII of the Companies Act, 2013 — delivered through our MCA-registered (CSR-1) partner trusts.",
      item2Title: "Transparent, Measurable Impact",
      item2Text:
        "Receive utilisation certificates, impact reports and photo documentation showing elders sheltered, meals served and treatments funded — ready for your board and annual CSR disclosures.",
      item3Title: "Employee Engagement",
      item3Text:
        "Give your teams meaningful volunteering opportunities — spend time with elders, serve meals or join Gaushala seva at our Lambha campus.",
      item4Title: "Brand Goodwill",
      item4Text:
        "Build trust with customers and communities by associating your brand with compassionate, grassroots social service.",
    },
    certificates: {
      eyebrow: "Registration",
      heading: "CSR Registration Certificates",
      subtitle:
        "Approval letters issued by the Office of the Registrar of Companies, Ministry of Corporate Affairs, Government of India.",
      registrationNo: "CSR Registration No.",
      pan: "PAN",
      dated: "Dated",
      srn: "Application SRN",
      issuedBy: "Issued By",
      address: "Registered Address",
      view: "View",
      download: "Download",
      previewAlt: "CSR registration certificate preview",
    },
    cta: {
      heading: "Ready to make a difference together?",
      text: "Share your details and our team will get in touch to plan a CSR partnership that fits your goals.",
      button: "Contact Us",
    },
    modal: {
      badge: "CSR Enquiry",
      title: "Partner With Us",
      subtitle:
        "Share your details and our team will get in touch to discuss CSR collaboration.",
      fullName: "Full Name",
      companyName: "Company / Organisation",
      mobile: "Mobile Number",
      email: "Email Address",
      area: "Area of Interest",
      areaPlaceholder: "Select a focus area",
      areaAny: "Open to any area",
      message: "Message",
      messagePlaceholder: "Tell us about your CSR goals, budget or timeline...",
      submit: "Send Enquiry",
      submitting: "Sending…",
      successTitle: "Thank you for reaching out!",
      successMessage:
        "We have received your CSR enquiry. Our team will contact you shortly.",
      close: "Close",
      nameRequired: "Please enter your full name",
      companyRequired: "Please enter your company or organisation name",
      mobileInvalid: "Enter a valid mobile number for the selected country.",
      error: "Could not send your enquiry. Please try again.",
    },
  },
  care: careEn,
  programs: programsEn,
  trust: trustEn,
  community: communityEn,
  pages: pagesEn,
  account: accountEn,
  csr: csrEn,
};

export type TranslationResources = typeof en;
